// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 📌 Conteneur principal du PDF */
.pdf-canvas-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;  /* Fond blanc pour un contraste plus doux */
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Ombre discrète */
  max-width: 100%;
  margin: 0 auto;
}

/* 📌 Mode plein écran - Scrolling activé */
.pdf-canvas-container[style*="overflow: auto"] {
  overflow: auto; /* Permet le défilement vertical */
  height: 100vh;  /* Prend toute la hauteur en plein écran */
}

/* 📌 Bouton "Plein écran" */
.fullscreen-btn {
  background-color: #007BFF;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-transform: uppercase;
  margin: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  /* Ombre légère */
}

.fullscreen-btn:hover {
  background-color: #0056b3;
  transform: scale(1.05); /* Légère animation au survol */
}

/* 📌 Bouton "Télécharger" */
.download-btn {
  background-color: #28a745; /* Vert pour le bouton télécharger */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-transform: uppercase;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.download-btn:hover {
  background-color: #218838;
  transform: scale(1.05); /* Animation au survol */
}

/* 📌 Contrôles de navigation (Précédent / Suivant) */
.pdf-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.pdf-controls button {
  background-color: #f0f0f0;  /* Couleur neutre pour les boutons */
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s ease;
}

.pdf-controls button:hover {
  background-color: #007BFF;
  color: white;
  transform: scale(1.05);  /* Effet de zoom au survol */
}

.pdf-controls button:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

/* 📌 Responsive pour mobile */
@media screen and (max-width: 768px) {
  .pdf-canvas-container {
    padding: 10px;
    max-width: 95%;
  }

  .fullscreen-btn, .download-btn {
    font-size: 12px;
    padding: 8px 12px;
  }

  .pdf-controls {
    flex-direction: column;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/Journal/PDFCanvasViewer.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB,GAAG,2CAA2C;EAC9D,aAAa;EACb,kBAAkB;EAClB,wCAAwC,EAAE,mBAAmB;EAC7D,eAAe;EACf,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,cAAc,EAAE,kCAAkC;EAClD,aAAa,GAAG,0CAA0C;AAC5D;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,yBAAyB;EACzB,YAAY;EACZ,wCAAwC,GAAG,iBAAiB;AAC9D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB,EAAE,+BAA+B;AACzD;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB,EAAE,wBAAwB;AAClD;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,GAAG,oCAAoC;EAChE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB,GAAG,4BAA4B;AACvD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":["/* 📌 Conteneur principal du PDF */\n.pdf-canvas-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;  /* Fond blanc pour un contraste plus doux */\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Ombre discrète */\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n/* 📌 Mode plein écran - Scrolling activé */\n.pdf-canvas-container[style*=\"overflow: auto\"] {\n  overflow: auto; /* Permet le défilement vertical */\n  height: 100vh;  /* Prend toute la hauteur en plein écran */\n}\n\n/* 📌 Bouton \"Plein écran\" */\n.fullscreen-btn {\n  background-color: #007BFF;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  text-transform: uppercase;\n  margin: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  /* Ombre légère */\n}\n\n.fullscreen-btn:hover {\n  background-color: #0056b3;\n  transform: scale(1.05); /* Légère animation au survol */\n}\n\n/* 📌 Bouton \"Télécharger\" */\n.download-btn {\n  background-color: #28a745; /* Vert pour le bouton télécharger */\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  text-transform: uppercase;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.download-btn:hover {\n  background-color: #218838;\n  transform: scale(1.05); /* Animation au survol */\n}\n\n/* 📌 Contrôles de navigation (Précédent / Suivant) */\n.pdf-controls {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.pdf-controls button {\n  background-color: #f0f0f0;  /* Couleur neutre pour les boutons */\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: background-color 0.3s, transform 0.2s ease;\n}\n\n.pdf-controls button:hover {\n  background-color: #007BFF;\n  color: white;\n  transform: scale(1.05);  /* Effet de zoom au survol */\n}\n\n.pdf-controls button:disabled {\n  background-color: #e0e0e0;\n  cursor: not-allowed;\n}\n\n/* 📌 Responsive pour mobile */\n@media screen and (max-width: 768px) {\n  .pdf-canvas-container {\n    padding: 10px;\n    max-width: 95%;\n  }\n\n  .fullscreen-btn, .download-btn {\n    font-size: 12px;\n    padding: 8px 12px;\n  }\n\n  .pdf-controls {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
